export function composedContact({
  email, firstName, lastName, cx
}) {
  if (!firstName || !lastName) {
    return email
  }
  if (!cx) {
    return `${firstName} ${lastName} - ${email}`
  }
  return `${firstName} ${lastName} - ${email} (CX: ${cx})`
}